module.exports = __webpack_public_path__ + "static/img/page3.37ba03d5.jpg";